// src/utils/seriesAllEvents.js — allkeep-6c2d9e14
//
// "All events" on a recurring series keeps the SERIES' OWN start date. The job form is opened
// through one visit and shows that visit's date and time; since 2026-07-01 (3492c9a) the "All
// events" save wrote that date straight onto the series, so a series opened at a later visit
// started again from there and every earlier visit vanished (found on TZR-5, 2026-10-18).
//
// The rule: only what the operator CHANGED applies. A change to the opened visit's start or end
// (e.g. 9 AM → 10 AM, or the visit moved a day) moves the series' own start / end by the same
// amount; no change → the series keeps its start and end exactly. "This and future" is different
// on purpose: it starts the series again from the opened visit (JobFormModal's other branch).
//
// The "opened" start / end are what the form was OPENED with on every path (an occurrence overlay,
// or the start the Calendar put on the series it hands over, or the series' own start).
//
// seriesTimesForAllEvents({ seriesStart, seriesEnd, openedStart, openedEnd, formStart, formEnd })
//   → { startAt, endAt } to write on the series, or null when the series' own times aren't known
//     (then the series' start and end are left exactly as they are).
// Pure: Dates, Firestore Timestamps or epoch ms in; Dates out.
const toMs = (v) => {
    if (v === null || v === undefined || v === '') return null;
    const d = typeof v?.toDate === 'function' ? v.toDate() : new Date(v);
    const t = d.getTime();
    return Number.isFinite(t) ? t : null;
};

export function seriesTimesForAllEvents({ seriesStart, seriesEnd, openedStart, openedEnd, formStart, formEnd }) {
    const sS = toMs(seriesStart); const sE = toMs(seriesEnd);
    const oS = toMs(openedStart); const fS = toMs(formStart); const fE = toMs(formEnd);
    if (sS === null || sE === null || oS === null || fS === null || fE === null) return null;
    const oE = toMs(openedEnd) ?? (oS + (sE - sS));
    return { startAt: new Date(sS + (fS - oS)), endAt: new Date(sE + (fE - oE)) };
}

// allkeep-6c2d9e14 — a saved rule REPLACES the stored one. The series writes are merges, and a
// merge keeps keys the new rule doesn't have: a "Custom every 2 weeks, never ends" series switched
// to the Bi-Weekly preset kept { interval, unit, neverEnds: true } beside its new end date, and
// then read as "never ends" (the form reopened on a 3-month default end; the phone showed
// "Forever"). The keys a preset doesn't carry are deleted explicitly. deleteField is passed in
// (firebase/firestore), so this file stays pure.
const CUSTOM_ONLY_KEYS = ['interval', 'unit', 'neverEnds'];
export function recurrenceForSeriesWrite(rule, deleteField) {
    const out = { ...rule };
    for (const k of CUSTOM_ONLY_KEYS) if (!(k in out)) out[k] = deleteField();
    return out;
}

// A stored rule means "never ends" only when it is a Custom rule saying so (or still holds the 2999
// sentinel). A preset left with an old Custom flag (see above) has a real end date.
export function storedNeverEnds(rule, storedEnd) {
    const sentinel = storedEnd instanceof Date && storedEnd.getFullYear() >= 2900;
    return sentinel || (rule?.frequency === 'Custom' && rule?.neverEnds === true);
}
